type Props = {
  value: any;
};

export const JsonViewer = (props: Props) => {
  return <pre>{JSON.stringify(props.value, null, 2)}</pre>;
};
